import { createRenderTarget } from '../../render-target'
import { AmpPicture } from '../../content/Picture/Picture.amp'
import {
    WebPicture,
    ResponsivePictureProps,
} from '../../content/Picture/Picture.web'
import { SimpleImg } from './SimpleImg'

// TODO Rename to ResponsivePicture
export const Picture = createRenderTarget<ResponsivePictureProps>('Picture', {
    amp: AmpPicture,
    web: WebPicture,
    rss: SimpleImg,
    preview: WebPicture,
    app: WebPicture,
})
